import { Location } from 'history';

export const SET_BACKGROUND_LOCATION = 'SET_BACKGROUND_LOCATION';
export const SET_IS_TRANSITIONING = 'SET_IS_TRANSITIONING';
export const INCREMENT_STACK = 'INCREMENT_STACK';
export const DECREMENT_STACK = 'DECREMENT_STACK';
export const RESET_STACK = 'RESET_STACK';

export interface SetBackgroundLocationAction {
  type: typeof SET_BACKGROUND_LOCATION;
  background: Location<unknown> | undefined;
}

export interface SetIsTransitioningAction {
  type: typeof SET_IS_TRANSITIONING;
  isTransitioning: boolean;
}

export interface IncrementStackAction {
  type: typeof INCREMENT_STACK;
}

export interface DecrementStackAction {
  type: typeof DECREMENT_STACK;
}

export interface ResetStackAction {
  type: typeof RESET_STACK;
}

export function setBackgroundLocation(background: Location<unknown>) {
  return {
    type: SET_BACKGROUND_LOCATION,
    background,
  };
}

export function removeBackgroundLocation(): SetBackgroundLocationAction {
  return {
    type: SET_BACKGROUND_LOCATION,
    background: undefined,
  };
}

export function setIsTransitioning(isTransitioning: boolean): SetIsTransitioningAction {
  return {
    type: SET_IS_TRANSITIONING,
    isTransitioning,
  };
}

export function incrementStack(): IncrementStackAction {
  return {
    type: INCREMENT_STACK,
  };
}

export function decrementStack(): DecrementStackAction {
  return {
    type: DECREMENT_STACK,
  };
}

export function resetStack(): ResetStackAction {
  return {
    type: RESET_STACK,
  };
}
